package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.COLON_SPLITTER
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.splitByRegex
import com.eladfinish.bible.contest.hebrew_aleph_bet
import com.eladfinish.bible.contest.neshama
import com.eladfinish.bible.contest.otiot_sofiot
import com.eladfinish.bible.contest.otiot_sofiot_final_form
import com.eladfinish.bible.contest.utils.removeWhitespacesAndParshiot
import com.eladfinish.bible.contest.utils.replaceKtivWithQriNew
import com.eladfinish.bible.contest.utils.replaceOtiotPasuk
import dev.icerock.moko.resources.desc.desc

//tehilim quf yud tet, alpha beta, neshama
class GetTehilim119UseCase(
    private val assetReader: AssetReader,
    private val stringResolver: StringResolver,
) {

    operator fun invoke(deceasedNameOriginal: String): String {
        val otiotSofiotFinalForm = stringResolver.resolveString(SharedRes.strings.otiot_sofiot_final_form.desc())
        val otiotSofiot = stringResolver.resolveString(SharedRes.strings.otiot_sofiot.desc())
        var deceasedName = deceasedNameOriginal
        otiotSofiotFinalForm.zip(otiotSofiot).forEach { (finalForm, regularForm) ->
            deceasedName = deceasedName.replace(finalForm, regularForm)
        }
        val filename = ChaptersRepository.getFileFormat(number = 27, bookName = "tehilim", chapter = "119")
        val chapter119 = assetReader.readFile(fileName = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filename)
        val content = chapter119
            .substringAfter(StringConstants.NEW_LINE)
            .replaceKtivWithQriNew()
            .trim()
        // first element is the title: תהילים פרק קיט
        val paragraphsByLetters = content.splitByRegex("\\{.\\}").drop(1).map {
            "$COLON_SPLITTER ${it.removeWhitespacesAndParshiot()}"
                .replaceOtiotPasuk(literalReplacement = "")
                .replaceRegex(regex = "$COLON_SPLITTER ?", replacement = "$COLON_SPLITTER\n")
                .trim()
        }
        val hebrewAlephBet = stringResolver.resolveString(SharedRes.strings.hebrew_aleph_bet.desc())
        val lettersToParagraphs: MutableMap<Char, String> = HashMap()
        // TODO: 17/07/2018 each paragraph starts with a letter - fix it
        for (i in paragraphsByLetters.indices) {
            lettersToParagraphs[hebrewAlephBet[i]] = paragraphsByLetters[i]
        }
        val neshama = stringResolver.resolveString(SharedRes.strings.neshama.desc())
        deceasedName += neshama
        val stringBuilder = StringBuilder()
        deceasedName.forEach {
            val paragraph = lettersToParagraphs[it]
            if (paragraph != null) {
                stringBuilder.append("▪ ").append(it).append(paragraph).append("\n\n")
            }
        }
        var output = "$deceasedNameOriginal \"$neshama\":\n\n$stringBuilder"
        output = "${output.trim()}\n"
        return output
    }
}
